module.exports = __webpack_public_path__ + "static/avatar-c26466b365c0e9f574f625179051dd75.jpeg";